export default function fillSetWithValues<T>(set: Set<T>, ...values: T[][]): void {
  values.forEach(list => {
    list.forEach(value => {
      set.add(value);
    });
  });
}
